export default __webpack_public_path__ + "static/media/28_tag_induction-cooker.e93d8f69.svg";